<template>

<com-item name="player.recent" :has-more="data.total > 5" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="Recent Plays">

	<template v-slot:about>

		<p>Most recent plays with {{ playername }}.</p>

	</template>

	<template v-slot:stats>

		<app-game :item="item" v-for="(item, index) in data.list" :key="index" :subtext="item.date | fromNow" :date="item.date" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		playername: function() {

			var name = this.player.name
			return name.split(' ')[0]

		},

		player: function() {

			return this.$store.getters['page/insights/player/player']

		},

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/player/recent']

		},

		active: function() {

			return this.data.list.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayerRecent'
			})
		
		}

	}

}

</script>

<style scoped>

</style>